import { useAuthenticationStore } from "../stores/authentication"

export default () => {
  const auth = useAuthenticationStore()

  if (!auth.canAccessSalesCampaigns) {
    return {
      success: false,
      path: "/sales/contracts",
    }
  }

  return {
    success: true,
  }
}
